export const setYears = () => {
  const options = [];
  const date = new Date();
  for (let i = date.getFullYear(); i >= 1900; i--) {
    options.push(i);
  }
  return options;
};
